import { Type } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { WidgetComponent } from 'app/views/presentations/widgets/widget.component';
import { PipesModule } from './../../../pipes/pipes.module';

export abstract class Widget {
    public abstract type: string;
    public abstract nameResourceKey: string;
    public abstract icon: string;
    public abstract componentType: Type<WidgetComponent>;
    public supported: boolean = true;
    public async getFormControls?(): Promise<AbstractControl[]> {
        return [];
    }
}



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/widget.ts